<!-- GoodsSwipe.vue -->
<template>
	<div class="swipe-wrapper ui-common-swiper" v-if="detailInfo">

<!--		<div v-if="detailInfo.goodsvideo_url">
    <div v-if="showVideo" class="iconfont m-btn close-btn" @click="showVideo=false">&#xe69a;</div>
		<div v-if="!showVideo" class="m-btn show-btn" @click="showVideo=true"><span class="iconfont">&#xe6c5;</span>视频</div>
		&lt;!&ndash; 视频 &ndash;&gt;
		<video class="ui-common-swiper goods-video" v-if="showVideo && detailInfo.goodsvideo_url" style="width:100%;height:100%" muted="muted" autoplay="autoplay" controls="controls" controlslist="nodownload" :src="detailInfo.goodsvideo_url" />
		</div>-->

    <!-- 轮播图 -->
		<mt-swipe
			:auto="0"
			class="ui-common-swiper goods-image"
			:prevent="false"
			:stop-propagation="true"
			@change="handleChange"
		>

      <mt-swipe-item v-if="detailInfo.goodsvideo_url">
<!--        <div v-if="playVideo" class="iconfont m-btn close-btn" @click="setVideoPlay(0)">
          <span><i></i></span>
        </div>-->
        <div v-if="playVideo" class="iconfont m-btn full-btn" @click="setVideoFull()">
          <span><i></i></span>
        </div>
        <div v-if="!playVideo" class="m-btn show-btn" @click="setVideoPlay(1)"><span><i></i></span></div>
        <!-- 视频 -->
        <video id="goods-video" class="ui-common-swiper goods-video" v-if="showVideo && detailInfo.goodsvideo_url" style="width:100%;height:100%" muted="muted" disablePictureInPicture controlslist="nodownload"
               @ended="resetVideo();"
               :poster="detailInfo.photos[0]"
               :src="detailInfo.goodsvideo_url" />
      </mt-swipe-item>

			<mt-swipe-item
				v-for="(item, index) in detailInfo.photos"
				v-bind:key="index"
				v-if="detailInfo.photos && detailInfo.photos.length > 0"
			>
				<img v-bind:src="item" v-on:click="setPopupVisible(index)" />
			</mt-swipe-item>
			<mt-swipe-item v-if="!detailInfo.photos || detailInfo.photos.length <= 0">
				<img
					src="../../../../assets/image/home/default_image_banner.png"
					class="product-img"
				/>
			</mt-swipe-item>
		</mt-swipe>

	</div>
</template>

<script>
import PreviewPicture from './PreviewPicture'
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {
	    showVideo: true,
      playVideo: false,
      popupVisible: false,
      index: 0
    }
  },

  components: {
    'v-picture': PreviewPicture
  },

  created () {
    this.$on('hide-priview-picture', value => {
      this.popupVisible = value
      this.setisPreviewPicture(value)
    })
  },

  computed: {
    ...mapState({
      detailInfo: state => state.goodsdetail.detailInfo
    })
  },

  methods: {
    ...mapMutations({
      setisPreviewPicture: 'setisPreviewPicture',
      setSwiperId: 'setSwiperId'
    }),

    setPopupVisible () {
      this.popupVisible = true
      this.setisPreviewPicture(true)
    },

    setVideoPlay (type) {
      var videL = document.getElementById('goods-video');
      if(type == 1){
        videL.play();
        this.playVideo = true;
      }else{
        videL.pause();
        this.playVideo = false;
      }
    },

    setVideoFull (){
      var videL = document.getElementById('goods-video');
      if(videL.requestFullScreen) {
        videL.requestFullScreen();
      } else if(videL.mozRequestFullScreen) {
        videL.mozRequestFullScreen();
      } else if(videL.webkitRequestFullScreen) {
        videL.webkitRequestFullScreen();
      }
    },

    resetVideo (){
      var videL = document.getElementById('goods-video');
      var videoSrc = videL.currentSrc;
      videL.src = '';
      videL.src = videoSrc;
      this.playVideo = false;
    },

    handleChange (index) {

      /*if(index == 0){
        this.showVideo = true;
      }else{
        this.showVideo = false;
      }*/

      /*var videL = document.getElementById('goods-video');
      if(videL){
        if(index == 0){
          videL.play();
        }else{
          videL.pause();
        }
      }*/

      this.index = index
      this.setSwiperId(index)
    }
  }
}
</script>

<style lang="scss">
	.swipe-wrapper{position: relative}
	.goods-image{position: absolute;z-index: 10;top:0;left:0}
	.goods-video{position: absolute;z-index: 14;top:0;left:0;background: #000}
	.m-btn{position: absolute;font-size:1rem;}
	.close-btn{
    top:.5rem;
    right:.5rem;
    z-index: 30;
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: 2rem;
    background: rgba(0,0,0,.3);
    color: #fff;
    font-size: .7rem;
    border: 1px solid #fff;
  }
  .close-btn span{
    position: absolute;
    z-index: 16;
    top: 50%;
    left: 50%;
    margin-top: -0.3rem;
    margin-left: -0.3rem;
    border-style: solid;
    text-indent: -9999px;
    border-color: transparent white;
    border-width: 0 0.24rem;
    height: 0.6rem;
    width: 0.1rem;
  }
  .show-btn{
    z-index: 15;
    width: 100%;
    height: 100%;
  }
  .full-btn{
    z-index: 15;
    width: 100%;
    height: 100%;
  }
	.show-btn span{
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -1.2rem;
    margin-left: -1.2rem;
    z-index: 15;
    width: 2.4rem;
    height: 2.4rem;
    line-height: 2.4rem;
    border-radius: 2.4rem;
    background: rgba(0,0,0,.3);
    color: #fff;
    font-size: .7rem;
    border: 1px solid #fff;
  }
  .show-btn span i{
    position: absolute;
    z-index: 16;
    top: 50%;
    left: 50%;
    margin-top: -0.4rem;
    margin-left: -0.2rem;
    border-style: solid;
    text-indent: -9999px;
    border-color: transparent transparent transparent #fff;
    border-width: .4rem 0 .4rem .6rem;
    width: 0;
    height: 0;
  }
.ui-common-swiper {
	width: 100%;
	height: 15rem !important;
	.mint-swipe-items-wrap {
		.mint-swipe-item {
			text-align: center;
			overflow: hidden;
			img {
				height: 100%;
				width: auto;
			}
		}
	}
	.mint-swipe-indicators {
    z-index: 999!important;
		div.mint-swipe-indicator {
			background: #efeff4;
			opacity: 1;
			&.is-active {
				background: $primaryColor;
			}
		}
	}
}
</style>
